import { graphql } from '../../../../graphql/generated';

export const CREATE_CATALOG_MUTATION = graphql(`
  mutation CreateCatalog($input: CatalogCreateInput!) {
    createCatalog(input: $input) {
      id
    }
  }
`);
